module.exports = __webpack_public_path__ + "img/btn1.2c0ca29b.png";